module.exports = __webpack_public_path__ + "assets/media/Louis_Granet_FR.32e58c32-ps.mp4";